import React from "react";
import "./ApprovalHeaderForm.scss";

export const ApprovalHeaderForm: React.FC = () => {
  return (
    <div className="document-header-container">
      <div className="country-info">
        <p>REPUBLIQUE DEMOCRATIQUE DU CONGO</p>
        <p>(Democratic Republic of Congo)</p>
      </div>
      <div className="ogefrem-info">
        <p>OFFICE DE GESTION DU FRET MULTIMODAL (OGEFREM)</p>
        <p>
          CONTRAT D'ADHESION AUX CONDITIONS D'ACCES AU FRET ROUTIER CONGOLAIS
        </p>
        <p>(Congolese road cargo access permit)</p>
      </div>
      <div className="decree-details">
        <p>
          Emis conformément au Décret N 09/63 du 03 décembre 2009, à l'Arrêté
          Interministériel N 08/CAB/VPM/MIN
        </p>
        <p>
          /TC/2019, N 12/CAB/Min/ECONAT/JKN/2019, N 63/CAB/MIN.ETAT/COEX/2019 et
          à l'Arrêté Ministériel N C
        </p>
        <p>
          /CAB/VPM/MIN-/TC/2019 du 22 janvier 2019 (Issued in accordance of
          Ministerial order)
        </p>
        <p>
          Emis sans surcharges ni ratures (issued without alterations or
          erasures)
        </p>
      </div>
    </div>
  );
};
